import React, { useEffect, useState } from 'react'
import Navbar from '../Components/Navbar'
import linkedIn from "../Images/linkedIn.png"
import github from "../Images/github.png"
import avatar from "../Images/avatar.png"
import downloadIcon from "../Images/donwload.png"
import whatshapp from "../Images/whatshapp.png"
import Spotify from "../Images/spotify.png"
import Apple from "../Images/apple.png"
import Twitter from "../Images/twitter.png"
import Password from "../Images/Password.png"
import {DiReact} from "react-icons/di"
import {SiJavascript} from "react-icons/si"
import {SiTypescript} from "react-icons/si"
import {SiNextdotjs} from "react-icons/si"
import {SiHtml5} from "react-icons/si"
import {SiCss3} from "react-icons/si"
import {BsGithub} from "react-icons/bs"
import {DiGit} from "react-icons/di"
import {SiVuedotjs} from "react-icons/si"
import {SiTailwindcss} from "react-icons/si"
import {SiPython} from "react-icons/si"
import {GrMysql} from "react-icons/gr"
import resume from "./resume.pdf"

function Home() {
    const projects = [
    {
      "name": "Spotify Clone",
      "img": Spotify,
      "repo": "https://github.com/YusufStar/Spotify-clone",
      "live": "https://spotify-vert-omega.vercel.app/",
      "techs": [{"name": "React JS"}, {"name": "Tailwind CSS"}]
    },
    {
      "name": "Apple Clone",
      "img": Apple,
      "repo": "https://github.com/YusufStar/apple-clone",
      "live": "https://apple-beryl.vercel.app/",
      "techs": [{"name": "React JS"}, {"name": "Tailwind CSS"}]
    },
    {
      "name": "Twitter Clone",
      "img": Twitter,
      "repo": "https://github.com/YusufStar/my-twitter-clone",
      "live": "https://twitter-eight.vercel.app/",
      "techs": [{"name": "React JS"}, {"name": "Tailwind CSS"}, {"name": "Firebase"}]
    },
    {
      "name": "Random Password Generator",
      "img": Password,
      "repo": "https://github.com/YusufStar/Random-Password-Generator",
      "live": "https://random-password-generator-ten.vercel.app/",
      "techs": [{"name": "React JS"}, {"name": "Tailwind CSS"}, {"name": "Math"}]
    },
    {
      "name": "Spotify Clone",
      "img": Spotify,
      "repo": "https://github.com/YusufStar/Spotify-clone",
      "live": "https://spotify-vert-omega.vercel.app/",
      "techs": [{"name": "React JS"}, {"name": "Tailwind CSS"}]
    },
    {
      "name": "Apple Clone",
      "img": Apple,
      "repo": "https://github.com/YusufStar/apple-clone",
      "live": "https://apple-beryl.vercel.app/",
      "techs": [{"name": "React JS"}, {"name": "Tailwind CSS"}]
    },
    {
      "name": "Twitter Clone",
      "img": Twitter,
      "repo": "https://github.com/YusufStar/my-twitter-clone",
      "live": "https://twitter-eight.vercel.app/",
      "techs": [{"name": "React JS"}, {"name": "Tailwind CSS"}, {"name": "Firebase"}]
    },
    {
      "name": "Random Password Generator",
      "img": Password,
      "repo": "https://github.com/YusufStar/Random-Password-Generator",
      "live": "https://random-password-generator-ten.vercel.app/",
      "techs": [{"name": "React JS"}, {"name": "Tailwind CSS"}, {"name": "Math"}]
    },
  ]
    
    useEffect(() => {
        document.title = "YusufStar"
    })

  return (
    <div className='w-[100%] flex scroll-smooth flex-col items-center'>
        <Navbar />

        {/* Home */}
        <section id='home' className='w-[85%] h-screen flex flex-col py-20 md:pt-0 md:flex-row items-center'>
          {/* Home Left */}
          <div className='flex w-auto md:w-[25%] flex-col gap-4'>
            <h1 className='w-40 h-[2.813rem] bg-[#7B4AE2]/10 flex items-center justify-center rounded-[16px] font-bold text-[20px] text-[#7B4AE2]'>👋Hiii!</h1>
            <h1 className='font-extrabold text-[52px]'>Yusuf Yıldız</h1>
            <h1 className='text-white/50 text-[20px] font-light'>Full-Stack developer · UI designer</h1>
            <div className='flex gap-4'>
              <img onClick={() => window.location.replace("https://www.linkedin.com/in/yusuf-star/")} className="hover:opacity-80 transition-all duration-100 cursor-pointer w-8" src={linkedIn}/>
              <img onClick={() => window.location.replace("https://github.com/YusufStar")} className="hover:opacity-80 transition-all duration-100 cursor-pointer w-8" src={github}/>
            </div>
          </div>

          {/* Home Middle */}
          <div className="w-[50%] h-screen flex items-center justify-center">
            <img src={avatar} alt="YusufStar"/>
          </div>

          {/* Home Right */}
          <div className="flex flex-col w-auto md:w-[25%] items-center gap-3">
            <a className='flex gap-2 items-center text-[#7B4AE2]/50 font-semibold text-sm' href={resume} download>Download CV <img className='flex-shrink-0 w-4 h-4' src={downloadIcon}/></a>
            <a className='text-[#7B4AE280]/50 font-[600] text-[16px] h-[45px] w-full md:w-[150px] flex items-center justify-center border-[1px] rounded-[18px] border-[#7B4AE280]/50' href="tel:+905524483327"><img src={whatshapp} className="w-6 h-6"/>Let's talk</a>
          </div>
        </section>

        <div className="border-b-[1px] border-[#7B4AE233]/20 w-screen"></div>

        {/* About Me */}

        <section id='about' className='w-[85%]'>
          <div className="w-full h-auto gap-5 flex flex-col md:flex-row py-10 pb-20 items-center justify-between">
            
            {/* About Left */}
            <img src="https://pps.whatsapp.net/v/t61.24694-24/236361426_565537061506106_5594200111650621032_n.jpg?ccb=11-4&oh=01_AdTGtVpTeXpJFXXWzGfWll99L9-xqO1yWFmLRObH4IFdSg&oe=637010B2" className='w-[200px] h-[200px] rounded-full'/>

            {/* About Right */}
            <div className="h-[50%s] w-[100%] flex flex-col">
              <h1 className='text-[#7B4AE2] w-[160px] h-[45px] rounded-[16px] flex items-center justify-center font-bold text-[20px] bg-[#7B4AE2]/10'>🧐 About Me</h1>
              <h1 className='font-[800] text-[48px]'>Yusuf Yıldız</h1>
              <h1 className='text-white/50 font-[400] text-[18px]'>👋 My name is Yusuf</h1>
              <h1 className='text-white/50 font-[400] text-[18px]'>👨‍💻 Developing and programming interfaces with JavaScript, React JS and Typescript for over 1 year.</h1>
              <h1 className='text-white/50 font-[400] text-[18px]'>🎓 Clarusway LLC, Full-Stack Web Developer from USA</h1>
              <h1 className='text-white/50 font-[400] text-[18px]'>💡 Interest in Full-Stack development with React, React Native, VueJS, MangoDB, Express.js and UX/UI Design.</h1>
              <h1 className='text-white/50 font-[400] text-[18px]'>🚀 Trying to be a little better every day than yesterday.</h1>
            </div>
          </div>
        </section>

        {/* Projects */}
        <section id='projects' className='w-[85%] h-[15%] flex flex-col items-start justify-between'>
          <h1 className='text-[48px] font-extrabold'>Projects</h1>
          <div className="min-w-full h-auto w-full overflow-x-auto overflow-y-hidden items-center gap-5 flex flex-row">
            {projects.map((proje) => (
              <div className="w-[360px] flex-shrink-0 h-[325px] rounded-[16px] border-[1px] my-3 border-[#7B4AE2]/50 flex flex-col items-center">
                <h1 className='font-bold text-[20px] pt-'>{proje.name}</h1>
                <img src={proje.img} className="w-[90%] rounded pb-3" alt={proje.name} />
                <div className="w-[90%] flex item-start gap-3">
                  {proje.techs.map((tech) => (
                    <>
                      <h1 className='p-2 border-[1px] border-[#7B4AE2]/50 rounded'>{tech.name}</h1>
                    </>
                  ))}
                </div>
                <div className="mt-3 w-[75%] flex flex-row items-center justify-between">
                  <button className='p-2 bg-[#7B4AE2]/50 px-5 hover:opacity-80 rounded-[17px]'><a href={proje.live} target="_blank">Live Site</a></button>
                  <button className='p-2 bg-[#7B4AE2]/50 px-5 hover:opacity-80 rounded-[17px]'><a href={proje.repo} target="_blank">Github</a></button>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Skills */}
        <section id='skills' className="w-auto h-screen py-3 skills flex flex-col items-center justify-center">
          <h1 className='text-[20px] font-[700] pt-20'>🧑‍💻 Skills</h1>
          <h1 className='text-[30px] md:text-[48px] font-[800]'>Technologies and skills</h1>
          <div className="w-auto h-auto flex flex-col gap-5">
            <div className="w-auto grid grid-cols-3 md:grid-cols-7 xl:grid-flow-col gap-10 pt-10 pr-7 pl-7 items-center justify-between h-auto">
              <DiReact  className='fill-[#7B4AE2]' size={32}/>
              <SiJavascript  className='fill-[#7B4AE2]' size={32}/>
              <SiTypescript  className='fill-[#7B4AE2]' size={32}/>
              <SiNextdotjs  className='fill-[#7B4AE2]' size={32}/>
              <DiReact  className='fill-[#7B4AE2]' size={32}/>
              <SiHtml5 className='fill-[#7B4AE2]' size={32}/>
              <SiCss3  className='fill-[#7B4AE2]' size={32}/>
              <BsGithub  className='fill-[#7B4AE2]' size={32}/>
              <DiGit  className='fill-[#7B4AE2]' size={32}/>
              <SiVuedotjs  className='fill-[#7B4AE2]' size={32}/>
              <SiTailwindcss  className='fill-[#7B4AE2]' size={32}/>
              <SiPython  className='fill-[#7B4AE2]' size={32}/>
              <GrMysql  className='fill-[#7B4AE2]' size={32}/>
            </div>
          </div>
        </section>

        {/* Footer */}
        <div className="w-full h-20 bg-[#7B4AE2]/10 items-center flex relative flex-row">
          <h1 className='text-white/50 ml-5 font-[400] w-[100%] text-[16px]'>Copyright © Yusuf yıldız · {new Date().getUTCFullYear()}</h1>
          <div className="w-full min-w-[600px] absolute h-full flex flex-row items-center justify-center gap-5">
            <img onClick={() => window.location.replace("https://www.linkedin.com/in/yusuf-star/")} className="hover:opacity-80 transition-all duration-100 cursor-pointer w-8" src={linkedIn}/>
            <img onClick={() => window.location.replace("https://github.com/YusufStar")} className="hover:opacity-80 transition-all duration-100 cursor-pointer w-8" src={github}/>
          </div>
        </div>
    </div>
  )
}

export default Home